'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fixIt = require('./fix-it');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fixIt).default;
  }
});

var _options = require('./options');

Object.defineProperty(exports, 'options', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_options).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fix-it/dist/index.js
// module id = 557
// module chunks = 0 1